import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AwsService } from "../../providers/appsyncservice/aws.service";
import { LoginService } from "../../service/login/login.service";
import { AuthService } from "../../guard/auth.service";
import { AppConstants } from "../../constants/app-constants";
var CryptoJS = require("crypto-js");

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  errorData: boolean = false;
  model: any = {};
  user_type: number;
  loginResult: any[] = [];

  constructor(
    public router: Router,
    public awserviceProvider: AwsService,
    protected activatedRoute: ActivatedRoute,
    private loginService: LoginService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    // this.activatedRoute.fragment.subscribe(async (fragment: string) => {
    //   this.oauthService.parseFragment(fragment);
    //   this.router.navigateByUrl(this.oauthService.getUrlBeforeAuthentication());
    // });
  }

  login() {
    let username = this.model.username;
    let password = this.model.password;

    this.awserviceProvider
      .LoginRncUser(username)
      .then((result) => {
        this.loginResult = result;
        if (this.loginResult.length > 0) {
          var hasedpass = result[0].password;
          var bytes = CryptoJS.AES.decrypt(hasedpass, AppConstants.cryptoKey);
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          if (plaintext === password) {
            if (result[0].user_type === 0) {
              this.user_type = 0;
              this.loginService.setUserType(0);
              this.auth.sendToken(username, "0");
              this.router.navigate(["./pages/dashboard"]);
            } else if (result[0].user_type === 1 || result[0].user_type === 2) {
              this.errorData = true;
            } else if (result[0].user_type === 4) {
              // console.log("login success", password)
              this.loginService.setUserType(4);
              this.user_type = 4;
              this.auth.sendToken(username, "4");
              this.router.navigate(["./pages/vehiclems"]);
            } else if (result[0].user_type === 5) {
              // console.log("login success", password)
              this.loginService.setUserType(5);
              this.user_type = 5;
              this.auth.sendToken(username, "5");
              this.router.navigate(["./pages/wellness"]);
            }
          } else {
            this.errorData = true;
          }
        } else {
          this.errorData = true;
        }
      })
      .catch((err) => {
        if (err) {
          // console.log("err.status "+err);
          this.errorData = true;
        }
      });
  }

  removeError() {
    this.errorData = false;
  }
}
